import styled from 'styled-components'
import { colours } from '@qflow/theme'
import { Flex, Text } from 'portal/lib/primitives'

export const LimitWidthContainer = styled.div`
  width: min(60rem, 100%);
  margin: 0 auto;
`
export const MainSection = styled.div`
  padding: 1.25rem 1.25rem 1.5rem 1.375rem;
  margin: 0 0 1.25rem -0.5rem;
  box-shadow: 0px 1px 3px 0px #00000026;
  background-color: ${colours.WHITE};
  border-radius: 10px;
  width: 100%;
`
export const MultiColumn = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
`
export const MultiColumnRow = styled.div`
  flex-grow: 1;
`
export const SubSection = styled.div`
  padding: 1rem 1.25rem 1.125rem;
  background-color: ${colours.CONTROL_PANEL_GREY};
  border-radius: 10px;
  margin-top: 0.625rem;
`
export const SubSectionHeading = styled.h3`
  color: ${colours.CORE_NAVY};
  font-size: 0.9375rem;
  font-family: 'Jakarta Sans', 'Roboto', sans-serif !important;
  font-weight: 700;
  line-height: 1.375rem;
`
export const StyledLabel = styled(Flex.Row)`
  gap: 4px;
  align-items: center;
`
export const TableSection = styled.div`
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td,
  .ant-table tfoot > tr > th,
  .ant-table tfoot > tr > td {
    padding: 0.5rem;
  }

  .ant-table-thead > tr > th {
    color: ${colours.BATTLESHIP_GREY};
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    span,
    sup {
      text-transform: none;
      letter-spacing: initial;
    }
  }

  .ant-table-wrapper .ant-table-tbody > .expanded-row-controlpanelgrey > td {
    background-color: ${colours.CONTROL_PANEL_GREY};
  }
`
export const NegativeMargin = styled.div`
  margin: 0 -0.5rem;
`
export const NameText = styled.span`
  font-weight: 600;
`
export const ExpanderOpen = styled.div`
  color: ${colours.TEAL};
  font-size: 0.75rem;
  cursor: pointer;

  > SPAN {
    text-decoration: underline;
  }
`
export const ExpanderClose = styled(ExpanderOpen)`
  color: ${colours.BATTLESHIP_GREY};
  font-size: 0.75rem;
  cursor: pointer;

  > SPAN {
    text-decoration: underline;
  }
`
export const BaseTag = styled(Text)`
  display: inline-block;
  padding: 0.125rem 0.5rem;
  border-radius: 3px;
  margin-right: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
`

export const ProductGroupTag = styled(BaseTag)`
  background-color: ${colours.CONSTRUCTION_ORANGE_BACKGROUND};
  color: ${colours.ORANGE};
`

export const UniclassClassificationCodeTag = styled(BaseTag)`
  background-color: ${colours.EXTRA_PALE_TEAL};
  color: ${colours.TEAL_TEXT};
`
export const TagContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
`
